import styled from "@emotion/styled";
import {
  calcRem,
  breakpoint,
  getElevationBySize
} from "@the-game/components/utils";
import { Card } from "@the-game/components";
import { StyledInlineRegistrationContainer } from "../registration/inline-registration.styled";
import sworlAfl from "./assets/mlp-sworl-sm.png";
import sworlMediumAfl from "./assets/mlp-sworl-md.png";
import sworlLargeLeftAfl from "./assets/mlp-sworl-left-lg.png";
import sworlLargeRightAfl from "./assets/mlp-sworl-right-lg.png";
import headerBackgroundLargeAfl from "./assets/header-lg.jpg";
import { environment } from "../../environments/environment";
export const MainPage = styled("div")({
  gridColumn: "1 / -1",
  boxShadow: "0px -8px 20px rgb(0 0 0 / 17%)",
  overflow: "hidden"
});
export const StyledHeaderSection = styled("div")((_) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "auto",
  flexDirection: "column",
  [breakpoint("lg")]: {
    flexDirection: "row"
  }
}));
export const StyledHeaderSectionWrapper = styled("div")((_) => ({
  position: "absolute",
  width: "100%",
  height: "80%",
  backgroundImage: `linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 5%, rgba(255,255,255,0) 95%, rgba(255,255,255,1) 100%), url("${headerBackgroundLargeAfl}")`,
  backgroundRepeat: "no-repeat",
  backgroundPositionX: "70%",
  backgroundPositionY: "50%",
  left: 0,
  top: 0,
  zIndex: -1,
  [breakpoint("sm")]: {
    height: "65%",
    backgroundPositionX: "40%"
  },
  [breakpoint("lg")]: {
    height: "100%",
    backgroundPositionX: "50%",
    backgroundPositionY: "25%",
    left: "-35%"
  }
}));
export const StyledHeroImage = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  minHeight: 290,
  minWidth: "100%",
  backgroundImage: `url("${environment.assetBaseUrl}/public-assets/featuredimage-small.png")`,
  backgroundRepeat: "no-repeat",
  backgroundPositionX: "center",
  backgroundPositionY: "top",
  backgroundSize: "cover",
  h1: {
    color: theme.colors.white,
    fontSize: calcRem(48),
    marginBottom: theme.spacing.md,
    lineHeight: 0.82,
    fontWeight: 900,
    textTransform: "uppercase",
    textAlign: "center",
    paddingTop: "20px"
  },
  h2: {
    color: theme.colors.white,
    fontSize: calcRem(24),
    lineHeight: 1,
    fontWeight: 500,
    textTransform: "uppercase",
    textAlign: "center",
    letterSpacing: calcRem(6),
    paddingTop: calcRem(16)
  },
  p: {
    color: theme.colors.white,
    fontSize: calcRem(12),
    fontWeight: 600,
    textTransform: "uppercase",
    textAlign: "center",
    letterSpacing: calcRem(6),
    paddingTop: calcRem(16)
  },
  [breakpoint("sm")]: {
    minHeight: 480,
    backgroundImage: `url("${environment.assetBaseUrl}/public-assets/featuredimage.png")`,
    backgroundSize: "cover",
    backgroundPositionY: "top",
    h1: {
      fontSize: calcRem(80),
      marginTop: `-${calcRem(112)}`
    },
    h2: {
      fontSize: calcRem(26),
      // marginTop: calcRem(8),
      letterSpacing: calcRem(12)
    }
  },
  [breakpoint("lg")]: {
    minHeight: 633,
    backgroundImage: `url("${environment.assetBaseUrl}/public-assets/featuredimage.png")`,
    minWidth: "60%",
    h1: {
      margin: calcRem(70),
      fontSize: calcRem(96),
      letterSpacing: "-2.5px",
      paddingTop: 0
    },
    h2: {
      marginBottom: calcRem(40),
      fontSize: calcRem(40),
      letterSpacing: calcRem(8)
    }
  }
}));
export const StyledHeaderSubheading = styled("div")(() => ({
  maxWidth: calcRem(220),
  [breakpoint("sm")]: {
    maxWidth: calcRem(300)
  },
  [breakpoint("md")]: {
    maxWidth: calcRem(352)
  },
  p: {
    fontSize: calcRem(18)
  },
  span: {
    marginBottom: 0
  }
}));
export const StyledOr = styled("div")(({ theme }) => ({
  height: "2rem",
  display: "grid",
  alignItems: "center",
  justifyContent: "center",
  gridTemplateColumns: "1fr 3rem 1fr",
  width: "100%",
  hr: {
    color: theme.colors.palette.neutral30,
    backgroundColor: theme.colors.palette.neutral30,
    borderColor: theme.colors.palette.neutral30,
    width: "100%"
  },
  span: {
    justifySelf: "center"
  }
}));
export const StyledRegistrationFormContainer = styled(
  StyledInlineRegistrationContainer
)(({ theme, isCricket }) => ({
  padding: theme.spacing.lg,
  paddingTop: theme.spacing.xl,
  [breakpoint("sm")]: {
    margin: "auto",
    maxWidth: "70%",
    zIndex: 1,
    ...isCricket && {
      background: "rgba(255, 255, 255, 0.8)",
      backdropFilter: "blur(16px)",
      borderRadius: "32px",
      padding: `${calcRem(40)} ${calcRem(96)} ${calcRem(48)} ${calcRem(
        96
      )}`,
      marginTop: `-${calcRem(132)}`
    }
  },
  [breakpoint("md")]: {
    ...!isCricket && { margin: "auto" },
    maxWidth: isCricket ? calcRem(638) : calcRem(544)
  },
  [breakpoint("lg")]: {
    marginTop: 10,
    background: theme.colors.white,
    padding: theme.spacing.xxxxl,
    paddingTop: calcRem(88),
    backdropFilter: "none",
    border: "none",
    margin: 0
  }
}));
export const RegistrationButtons = styled("div")(() => ({
  button: {
    ...getElevationBySize(1)
  }
}));
export const StyledHeaderSubParagraph = styled("div")(({ theme }) => ({
  button: {
    fontWeight: 500
  },
  [breakpoint("lg")]: {
    p: {
      color: theme.colors.palette.neutral70
    }
  }
}));
export const StyledHowToPlaySection = styled("section")(({ theme }) => ({
  gridColumn: "1 / -1",
  backgroundImage: `url("${sworlAfl}")`,
  backgroundRepeat: "no-repeat",
  padding: `${calcRem(theme.spacing.xxxl)} ${calcRem(theme.spacing.lg)}`,
  backgroundSize: "cover",
  position: "relative",
  [breakpoint("sm")]: {
    padding: `${calcRem(90)} ${calcRem(80)} ${calcRem(70)} ${calcRem(80)}`,
    backgroundImage: `linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 10%, rgba(255,255,255,0) 100%), url("${sworlMediumAfl}")`,
    backgroundSize: "100% 130%",
    backgroundPositionY: "15%"
  },
  [breakpoint("md")]: {
    padding: `${calcRem(90)} ${calcRem(theme.spacing.lg)} ${calcRem(
      70
    )} ${calcRem(theme.spacing.lg)}`,
    backgroundImage: `url("${sworlLargeLeftAfl}"), url("${sworlLargeRightAfl}")`,
    backgroundPositionY: 0,
    backgroundSize: "auto",
    backgroundPosition: "top left, top right"
  }
}));
export const StyledHowToPlayCard = styled(Card)(({ theme }) => ({
  display: "grid",
  borderRadius: calcRem(8),
  ...getElevationBySize(3),
  h2: {
    textAlign: "center",
    fontSize: calcRem(33),
    marginBottom: theme.spacing.lg,
    [breakpoint("sm")]: {
      fontSize: calcRem(39)
    },
    [breakpoint("lg")]: {
      fontSize: calcRem(51)
    }
  },
  h3: {
    fontSize: calcRem(23),
    marginBottom: theme.spacing.xs,
    [breakpoint("sm")]: {
      fontSize: calcRem(25)
    },
    [breakpoint("lg")]: {
      fontSize: calcRem(28)
    }
  },
  p: {
    fontSize: calcRem(18),
    marginBottom: theme.spacing.lg
  },
  a: {
    ...getElevationBySize(1)
  },
  [breakpoint("sm")]: {
    margin: "auto",
    padding: calcRem(theme.spacing.lg)
  },
  [breakpoint("md")]: {
    maxWidth: "70%",
    margin: `${calcRem(theme.spacing.xxxxl)} auto`,
    h3: {
      marginBottom: theme.spacing.md
    }
  },
  [breakpoint("lg")]: {
    padding: calcRem(82),
    gridTemplateColumns: "1fr 1fr",
    gridGap: theme.spacing.xxxl,
    maxWidth: calcRem(1160),
    h2: {
      gridColumn: "1 / -1"
    },
    a: {
      gridColumn: "1 / -1",
      width: "309px",
      margin: "auto"
    },
    button: {
      gridColumn: "1 / -1",
      width: "309px",
      margin: "auto"
    }
  }
}));
export const StyledLine = styled("div")(({ theme }) => ({
  backgroundColor: theme.colors.palette.neutral50,
  height: "80%",
  width: 1,
  display: "flex",
  gridRow: "1 / -1",
  alignSelf: "center",
  [breakpoint("lg")]: {
    display: "none"
  }
}));
export const StyledAdBanner = styled("div")(({ theme }) => ({
  display: "none",
  [breakpoint("md")]: {
    gridColumn: "1 / -1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: theme.spacing.xl
  }
}));
export const StyledDualLogoContainer = styled("div")(({ theme }) => ({
  alignSelf: "center",
  justifySelf: "center",
  zIndex: 1,
  gridColumn: "2 / -2",
  display: "none",
  gridTemplateColumns: "50px 1px auto",
  gridTemplateRows: "1fr 1fr",
  gridColumnGap: theme.spacing.md,
  [breakpoint("lg")]: {
    display: "grid",
    gridTemplateColumns: "101px auto",
    justifySelf: "flex-start",
    alignSelf: "flex-start",
    gridColumnGap: theme.spacing.xxxxl
  },
  "> :first-child": {
    gridRow: "1 / -1",
    height: 50,
    width: 52,
    fill: theme.colors.black,
    alignSelf: "center",
    [breakpoint("lg")]: {
      fill: theme.colors.white,
      height: 96,
      width: 100
    }
  },
  span: {
    color: theme.colors.black,
    opacity: 0.6,
    fontSize: calcRem(12),
    alignSelf: "flex-end",
    [breakpoint("lg")]: {
      fontSize: calcRem(16),
      color: theme.colors.white
    }
  },
  "> :last-child": {
    alignSelf: "flex-start",
    width: 77,
    height: 24,
    [breakpoint("lg")]: {
      fill: theme.colors.white,
      width: 114,
      height: 36
    }
  }
}));
export const StyledCustomHeroWrapper = styled("div")({
  margin: "0 0",
  width: "80%",
  paddingLeft: 10,
  "h1,h2,p": {
    textAlign: "left",
    marginLeft: 0
  },
  [breakpoint("sm")]: {
    margin: "0 auto",
    width: 720,
    "h1,h2,p": {
      textAlign: "left"
    }
  },
  [breakpoint("lg")]: {
    width: 820
  }
});
export const StyledHeading = styled("h1")({
  filter: "drop-shadow(0px 1px 0px rgba(0, 0, 0, 0.75))",
  maxWidth: 800
});
export const HeroSubtitleImage = styled("div")({
  position: "relative",
  marginBottom: "20px",
  maxWidth: "220px",
  [breakpoint("sm")]: {
    maxWidth: "50%",
    marginBottom: "60px"
  }
});
export const StyledSmallHeading = styled("h2")({
  filter: "drop-shadow(0px 3px 0px rgba(0, 0, 0, 0.75))",
  marginBottom: -15,
  [breakpoint("sm")]: {
    br: {
      display: "none"
    }
  },
  [breakpoint("lg")]: {
    width: 570
  }
});
export const StyledParagraph = styled("p")({
  filter: "drop-shadow(0px 2px 0px rgba(0, 0, 0, 0.75))",
  marginTop: 30,
  marginBottom: 30
});
